// extracted by mini-css-extract-plugin
module.exports = {"cls1":"LoadingSheet-Sheet-module--cls1--20Kt6","cls2":"LoadingSheet-Sheet-module--cls2--iygCL LoadingSheet-Sheet-module--cls1--20Kt6"};